/* 
 * 车牌号专用输入框，用于车牌字母转为大写
 * 
 * @Author: MasonChen 
 * @Date: 2018-01-10 10:39:17 
 * @Last Modified by: MasonChen
 * @Last Modified time: 2018-02-09 08:56:50
 */
<template>
    <input
        type="text"
        class="form-control"
        ref="vinput"
        v-bind:value="value"
        v-on:input="updateValue($event.target.value)"
        v-on:blur="formatValue"
        v-on:compositionstart="zhStart"
        v-on:compositionend="zhEnd($event.target.value)"
    >
</template>
<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            zhInputing: false
        }
    },
    mounted: function () {
        this.formatValue()
    },
    methods: {
        updateValue: function (value) {
            if(this.zhInputing) return;
            var result = value.toUpperCase();
            this.$emit('input', result)
        },
        formatValue: function () {
            this.$refs.vinput.value = this.value.toUpperCase()
        },
        zhStart() {
            this.zhInputing = true;
        },
        zhEnd(value) {
            this.zhInputing = false;
            var result = value.toUpperCase();
            this.$emit('input', result)
        }
    }
}
</script>




// WEBPACK FOOTER //
// VplateInput.vue?bfc1dab6